import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./Polymatch.module.css";
import Footer from "../Footer";
// import {/* <CertificateVerification /> */} from "../{/* <CertificateVeFrification /> */}";
import Testimonials from "../Testimonials";
import FAQ from "../FooterPages/newfaq";
import { Link } from "react-router-dom";
import polymatchLogo from "../../assets/polymatchlogo.png";
import poly1 from "../../assets/polymatch1.png";
import poly2 from "../../assets/polymatch2.png";
import polyeng from "../../assets/polyeng.png";
import polymath from "../../assets/polymath.png";
import polysci from "../../assets/polysci.png";
import polycode from "../../assets/polycode.png";
import polygraphic from "../../assets/polygraphic.png";
import polyiq from "../../assets/polyiq.png";
import polyislamic from "../../assets/polyislamic.png";
import polyart from "../../assets/polyart.png";
// import arrowLeft from "../../assets/arrowleft.png";
// import arrowRight from "../../assets/arrowright.png";
import flagPakistan from "../../assets/pakistan.png";
import flagJapan from "../../assets/japan.png";
import flagSaudiArabia from "../../assets/saudi_arabia.png";
import flagNorway from "../../assets/norway.png";
import flagUAE from "../../assets/united_arab_emirates.png";
import flagUSA from "../../assets/united_states_of_america.png";
// import polystudent from "../../assets/polystudent.png";
// import polyglobal from "../../assets/polyglobal.png";
// import polylearning from "../../assets/polylearning.png";
// import polytop from "../../assets/polytop.png";
// import polygame from "../../assets/polygame.png";
// import polymaterial from "../../assets/polymaterial.png";
// import polylive from "../../assets/polylive.png";
// import polytrophy from "../../assets/polytrophy.png";
// import polyans from "../../assets/polyans.png";
import hand from "../../assets/hand.png";
// import polyex from "../../assets/polyex.png";
// import polystu from "../../assets/polystu.png";
// import polyearly from "../../assets/polyearly.png";
import GallerySection from "../GallerySection";

import { Helmet } from "react-helmet";
import API_CONFIG from '../../config/api';
const Polymatch = () => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const location = useLocation();

  const advantages = [
    {
      imgSrc: 'Polymath-images/polygame.png',
      alt: "Gamified",
      title: "Gamified",
      text: "Makes learning fun and engaging through points, badges, and challenges.",
    },
    {
      imgSrc: 'Polymath-images/polyglobal.png',
      alt: "Global Access",
      title: "Global Access",
      text: "Students from any country can join and learn together.",
    },
    {
      imgSrc: 'Polymath-images/polylive.png',
      alt: "Live Quiz Competitions",
      title: "Live Quiz Competitions",
      text: "Students compete in real-time, making learning fun and fast-paced.",
    },
    {
      imgSrc: 'Polymath-images/polymaterial.png',
      alt: "Material Ready",
      title: "Material Ready",
      text: "All topics and syllabus provided.",
    },
    {
      imgSrc: 'Polymath-images/polyans.png',
      alt: "Answer Display",
      title: "Answer Display",
      text: "Understand better with shown solutions during competition.",
    },
    {
      imgSrc: 'Polymath-images/polytop.png',
      alt: "Top 3 Students Result",
      title: "Top 3 Students Result",
      text: "Live leaderboard shows top 3 students instantly after each competition.",
    },
    {
      imgSrc: 'Polymath-images/polystudent.png',
      alt: "Student Video Participation",
      title: "Student Video Participation",
      text: "Showcase learner interviews to boost confidence and engagement.",
    },
    {
      imgSrc: 'Polymath-images/polylearning.png',
      alt: "Learning Through Competition",
      title: "Learning Through Competition",
      text: "Students learn a lot in real-time as each competition reinforces understanding instantly.",
    },
    {
      imgSrc: 'Polymath-images/polytrophy.png',
      alt: "Trophies & Digital Certificates",
      title: "Trophies & Digital Certificates",
      text: "Earn rewards for outstanding progress.",
    },
  ];

  const partnershipItems = [
    {
      imgSrc: 'Polymath-images/polyex.png',
      alt: "Exclusive Rights",
      title: "Exclusive Rights",
      text: "Get exclusive access to run PolyMatch programs in your area, positioning you as a local leader in education.",
    },
    {
      imgSrc: 'Polymath-images/polystu.png',
      alt: "Student Discounts",
      title: "Student Discounts",
      text: "Your students enjoy special discounted rates on all PolyMatch programs.",
    },
    {
      imgSrc: 'Polymath-images/polyearly.png',
      alt: "Early Access",
      title: "Early Access",
      text: "Be the first to join global competitions, events, and programs—giving your students a competitive edge.",
    },
  ];

  useEffect(() => {
    if (location.hash === "#global-challenges") {
      const el = document.getElementById("global-challenges");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>PolyMatch Global Competitions | Science, Math, Coding & More</title>
        <meta name="description" content="Join PolyMatch Global Competitions 2025 and challenge your skills in science, coding, math, arts, and more. Open to students worldwide, with gamified learning, global access, and certificates." />
      </Helmet>
      <section className={styles.headerSection}>
        <div className={styles.headerContainer}>
          <img
            src={polymatchLogo}
            alt="Polymatch Logo"
            className={styles.polymatchLogo}
          />
          <h1 className={styles.headerHeading}>
            PolyMatch is a global competition platform by Polymath-Kids, dedicated
            to providing STEM education and 21st-century life skills in a fun,
            engaging environment. Through competitions like Mental Math, Coding,
            Islamic Knowledge, Declamation, and Graphic Designing, PolyMatch
            nurtures young minds and inspires intellectual exploration across the
            globel.
          </h1>
          <div className={styles.headerButtons}>
            <Link to="/PolymatchReg" className={styles.registerBtn}>Register</Link>
            <Link to="/PolymatchDetail" className={styles.detailsBtn}>Details for Competition</Link>
          </div>
          <img src={poly1} alt="Poly 1" className={styles.poly1Img} />
          <img src={poly2} alt="Poly 2" className={styles.poly2Img} />
        </div>
      </section>

      <section className={styles.competitionsSection} id="global-challenges">
        <h2 className={styles.competitionsHeading}>
          <span className={styles.competitionsPart1}>PolyMatch Competitions – Global </span><br />
          <span className={styles.competitionsPart2}>Challenges for Young Minds</span>
        </h2>
        <div className={styles.competitionsGrid}>
          <div className={styles.competitionItem}>
            <Link to="/Polymatch/Global_English_Linguistic_Competition">
              <img src={polyeng} alt="English Linguistic Competition" className={styles.competitionImage} />
            </Link>
          </div>
          <div className={styles.competitionItem}>
            <Link to="/Polymatch/Global_Mental_Math_Competition">
              <img src={polymath} alt="Mental Math Competition" className={styles.competitionImage} />
            </Link>
          </div>
          <div className={styles.competitionItem}>
            <Link to="/Polymatch/Global_Science_Knowledge_Competition">
              <img src={polysci} alt="Science Competition" className={styles.competitionImage} />
            </Link>
          </div>
          <div className={styles.competitionItem}>
            <Link to="/Polymatch/Global_Coding_Competition">
              <img src={polycode} alt="Coding Competition" className={styles.competitionImage} />
            </Link>
          </div>
          <div className={styles.competitionItem}>
            <Link to="/Polymatch/Global_Graphic_designing_Competition">
              <img src={polygraphic} alt="Graphic Designing Competition" className={styles.competitionImage} />
            </Link>
          </div>
          <div className={styles.competitionItem}>
            <Link to="/Polymatch/Global_IQ_Competition">
              <img src={polyiq} alt="IQ Competition" className={styles.competitionImage} />
            </Link>
          </div>
          <div className={styles.competitionItem}>
            <Link to="/Polymatch/Global_Islamic_Knowledge_Competition">
              <img src={polyislamic} alt="Islamic Knowledge Competition" className={styles.competitionImage} />
            </Link>
          </div>
          <div className={styles.competitionItem}>
            <img src={polyart} alt="Arts and Poster Competition" className={styles.competitionImage} />
          </div>
        </div>
      </section>

      <section className={styles.upcomingCompetitionSection}>
        <h2 className={styles.upcomingCompetitionHeading}>
          <span className={styles.upcomingCompetitionPart1}>Our Upcoming Competition Is On </span><br />
          <span className={styles.upcomingCompetitionPart2}>21st November 2025</span>
        </h2>
        <h3 className={styles.globalScienceHeading}>Global Mental Math Competition</h3>
        <p className={styles.globalScienceParagraph}>
          Welcome to the Polymatch Global Mental Math Competition 2025!
          Polymatch brings together young minds from around the world to challenge their speed, accuracy, and problem-solving skills in mathematics. With age-appropriate competitions designed for learners as young as 4 and up to 16, this exciting competition covers everything from counting and patterns to algebra, fractions, and logic puzzles. Compete with peers globally, sharpen your mental agility, and experience the thrill of solving math on the spot — all in a fun, friendly, and fair challenge.
        </p>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <div className={styles.flagsWrapper}>
          <img src={flagPakistan} alt="Pakistan Flag" className={styles.flagImage} />
          <img src={flagJapan} alt="Japan Flag" className={styles.flagImage} />
          <img src={flagSaudiArabia} alt="Saudi Arabia Flag" className={styles.flagImage} />
          <img src={flagNorway} alt="Norway Flag" className={styles.flagImage} />
          <img src={flagUAE} alt="United Arab Emirates Flag" className={styles.flagImage} />
          <img src={flagUSA} alt="United States of America Flag" className={styles.flagImage} />
        </div>

      </section>

      <section className={styles.advantagesSection}>
        <h2 className={styles.advantagesHeading}>
          <span className={styles.advantagesPart1}>Advantages of Participating in </span><br />
          <span className={styles.advantagesPart2}>PolyMatch Competitions</span>
        </h2>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <div className={styles.advantagesGrid}>
          {advantages.map((advantage, index) => (
            <div key={index} className={styles.advantageItem}>
              <img
                src={`${API_CONFIG.IMAGES_URL}/${advantage.imgSrc}`}
                alt={advantage.alt}
                className={styles.advantageImage}
              />
              <h3 className={styles.advantageTitle}>{advantage.title}</h3>
              <p className={styles.advantageText}>{advantage.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className={styles.schoolsSection}>
        <h2 className={styles.schoolsHeading}>
          <span className={styles.schoolsPart1}>PolyMatch for Schools – </span><br />
          <span className={styles.schoolsPart2}>Partner with Us</span>
        </h2>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <div className={styles.handImageContainer}>
          <img src={hand} alt="Handshake" className={styles.handImage} />
        </div>

        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <p className={styles.schoolsParagraph}>
          Join hands with PolyMatch and bring the best of 21st-century life skills to your students through our dynamic, curriculum-integrated programs. Our exclusive partnership will empower your school to equip students with the critical skills they need to excel in today's fast-paced world. Together, we can create an environment where creativity, collaboration, and critical thinking flourish.
        </p>

        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <h3 className={styles.partnershipSubHeading}>What You Get with Our Partnership</h3>

        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <div className={styles.partnershipGrid}>
          {partnershipItems.map((item, index) => (
            <div key={index} className={styles.partnershipItem}>
              <img
                src={`${API_CONFIG.IMAGES_URL}/${item.imgSrc}`}
                alt={item.alt}
                className={styles.partnershipImage}
              />
              <h3 className={styles.partnershipTitle}>{item.title}</h3>
              <p className={styles.partnershipText}>{item.text}</p>
            </div>
          ))}
        </div>

        <h3 className={styles.readyHeading}>Ready to Get Started?</h3>
        <p className={styles.readyParagraph}>
          Contact us today to learn more about how PolyMatch can enhance your school's curriculum and empower your students. Register your interest now and take the first step toward creating a future-ready generation.
        </p>

        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        {/* <Link to="/PolymatchReg" className={styles.registerBtn}>Register Now</Link> */}
      </section>

      {/* <{/* <CertificateVerification /> */}

      {/* <section className={styles.sponsorsSection}>
        <h2 className={styles.sponsorsHeading}>
          <span className={styles.sponsorsPart1}>Our Sponsors & </span><br />
          <span className={styles.sponsorsPart2}>Strategic Partners</span>
        </h2>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <div className={styles.sponsorsGrid}>
          <div className={styles.sponsorItem}>
            <img src={ss1} alt="Sponsor 1" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss2} alt="Sponsor 2" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss3} alt="Sponsor 3" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss4} alt="Sponsor 4" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss5} alt="Sponsor 5" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss6} alt="Sponsor 6" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss7} alt="Sponsor 7" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss8} alt="Sponsor 8" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss9} alt="Sponsor 9" className={styles.sponsorImage} />
          </div>
        </div>
      </section> */}

      <Testimonials />
      <FAQ />
      {/* <section className={styles.gallerySection}>
        <div className={styles.container}>
          <div className={styles.galleryHeader}>
            <h2 className={styles.galleryTitle}>
              <span className={styles.galleryOf}>Gallery of </span>
              <span className={styles.learningGrowth}>Learning & Growth</span>
            </h2>
            <div className={styles.sunIcon}>
              <img src={require("../../assets/sun.png")} alt="Sun" />
            </div>
          </div>
          <div className={styles.galleryGrid}>
            {[...Array(8)].map((_, i) => (
              <div className={styles.galleryItem} key={i}>
                <img
                  src={require(`../../assets/kid${i + 7}.png`) || "/placeholder.svg"}
                  alt="Learning child"
                />
              </div>
            ))}
          </div>
          <div className={styles.calculatorIcon}>
            <img src={require("../../assets/calculator.png")} alt="Calculator" />
          </div>
          <div className={styles.galleryButton}>
            <Link to="/gallery">
              <img
                src={require("../../assets/viewgallery.png")}
                alt="View Gallery"
              />
            </Link>
          </div>
        </div>
      </section> */}
      <div>
        <GallerySection />
      </div>
      <Footer />
    </>
  );
};

export default Polymatch;